import { render, staticRenderFns } from "./IntentsList.vue?vue&type=template&id=57b827e7"
import script from "./IntentsList.vue?vue&type=script&lang=js"
export * from "./IntentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports